import "./JobCard.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setApplications, setEditJobId, setForEdit } from "../../app/state/userSlice";
import { useNavigate } from "react-router-dom";
import { apply_job, view_applications } from "../../utilities/apis";


const JobCard = ({ jobDetails, onDelete, setJobTitle}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const skillsArray = jobDetails.req_skills.split(",");

  const handleClick = () => {
    console.log(jobDetails.job_id);
    onDelete(jobDetails.job_id);
  };

  const isEmployer =
    useSelector((state) => state.user.userRole) === "employer" ? true : false;
  const userName = useSelector((state) => state.user.userID);


  async function viewApplicants(){
    const applicants_res = await view_applications({
      job_id:jobDetails.job_id
    })
    if(applicants_res.success){
      dispatch(setApplications(applicants_res.applications));
    }
  }

  const handleView = () => {
    if (isEmployer) {
      viewApplicants(jobDetails.job_id);
      navigate("/view-applicants");
      
    } else {
      navigate("/view-job");
    }
  };

  const handleApplyClick = async () => {
    try {
      setJobTitle(jobDetails.job_title,jobDetails.job_id)
    } catch (error) {
      console.log(error);
    }
  };

  const skillsBadge = (
    <div className="skills-container">
      {skillsArray.map((skills, index) => {
        return <div className="skill-badge">{skills}</div>;
      })}
    </div>
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 mt-5">
        <div className="card cardbg-1 p-3 shadow">
          <div className="card cardbg-2">
            <div className="card-body">
              <div className="jobCardHead">
                <h5 className="card-title">{jobDetails.job_title}</h5>
                <div className="ctrl-buttons">
                  {isEmployer && (
                    <Link to={`/postjob`}>
                      <i
                        class="fa-solid fa-pen-to-square edtDlt"
                        onClick={() => {
                          dispatch(setEditJobId(jobDetails.job_id));
                          dispatch(setForEdit(true));
                        }}
                      ></i>
                    </Link>
                  )}

                  {isEmployer && (
                    <i
                      onClick={handleClick}
                      class="fa-solid fa-trash edtDlt"
                    ></i>
                  )}
                </div>
              </div>
              <div className="sub-heading">
                <div className="company-name ">
                  {jobDetails.company_information}
                </div>
                <div className="job-location py-2 px-2">
                  <i class="fa-solid fa-location-dot"></i>
                  {jobDetails.location}
                </div>
              </div>
              <div className="card-text-description">
                {jobDetails.job_description}
              </div>
              {/* <div className='extra-details'>
                <p className='card-text'>{jobDetails.experience}</p>
                <p className='card-text'>{jobDetails.experience}</p>

              </div> */}

              <div className="expSa">
                <div className="Experiance p-2">
                  Experience:{jobDetails.experience}
                </div>
                <div className="Salary p-2">
                  Salary:{jobDetails.salary_compensation}
                </div>
              </div>

              {skillsBadge}
              {/* Commented for Demo */}
              <button className='btn btn-primary btn-sm m-1 jobBtn' onClick={handleView}>
              {isEmployer ? "View Applications" : "View Job"}
              </button>
              {!isEmployer && (
                <button
                  className="btn btn-outline-primary btn-sm m-1 jobBtn"
                  onClick={handleApplyClick}
                  disabled={jobDetails.applied_status}
                >
                  {jobDetails.applied_status ? "Applied" : "Apply"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobCard;
